/**
 * ArbiHunter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: ROOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class VacancyQueryStatsDTO {
    'categories'?: Array<string>;
    'skills'?: Array<string>;
    'countries'?: Array<string>;
    'cities'?: Array<string>;
    'employment'?: Array<VacancyQueryStatsDTOEmploymentEnum>;
    'schedule'?: Array<VacancyQueryStatsDTOScheduleEnum>;
    'compensation'?: Array<VacancyQueryStatsDTOCompensationEnum>;
    'experience'?: Array<VacancyQueryStatsDTOExperienceEnum>;
    'search'?: string;
    'currency'?: string;
    'isRemote'?: boolean;
    's'?: any;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "categories",
            "baseName": "categories",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "skills",
            "baseName": "skills",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "countries",
            "baseName": "countries",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "cities",
            "baseName": "cities",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "employment",
            "baseName": "employment",
            "type": "Array<VacancyQueryStatsDTOEmploymentEnum>",
            "format": ""
        },
        {
            "name": "schedule",
            "baseName": "schedule",
            "type": "Array<VacancyQueryStatsDTOScheduleEnum>",
            "format": ""
        },
        {
            "name": "compensation",
            "baseName": "compensation",
            "type": "Array<VacancyQueryStatsDTOCompensationEnum>",
            "format": ""
        },
        {
            "name": "experience",
            "baseName": "experience",
            "type": "Array<VacancyQueryStatsDTOExperienceEnum>",
            "format": ""
        },
        {
            "name": "search",
            "baseName": "search",
            "type": "string",
            "format": ""
        },
        {
            "name": "currency",
            "baseName": "currency",
            "type": "string",
            "format": ""
        },
        {
            "name": "isRemote",
            "baseName": "isRemote",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "s",
            "baseName": "s",
            "type": "any",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return VacancyQueryStatsDTO.attributeTypeMap;
    }

    public constructor() {
    }
}

export enum VacancyQueryStatsDTOEmploymentEnum {
    FULL_TIME = 'fullTime',
    PART_TIME = 'partTime',
    PROJECT = 'project'
}
export enum VacancyQueryStatsDTOScheduleEnum {
    FULL_DAY = 'fullDay',
    FLEXIBLE = 'flexible',
    REMOTE = 'remote'
}
export enum VacancyQueryStatsDTOCompensationEnum {
    SALARY = 'salary',
    COMMISSION = 'commission',
    GYBRID = 'gybrid',
    PIECEWORK = 'piecework',
    CONTRACT = 'contract'
}
export enum VacancyQueryStatsDTOExperienceEnum {
    NO_EXPERIENCE = 'noExperience',
    FROM1TO3 = 'from1to3',
    FROM3TO6 = 'from3to6',
    FROM6 = 'from6'
}

